import React, {useEffect, useState, useRef} from 'react'
import { isArray } from 'lodash'
import TagManager from 'react-gtm-module'
import { LeadGenCrossContainer, StyledImage, Privacy1stdiv, Privacy2nddiv,FormFieldsDiv, FieldContainer, ErrorContainer, FieldAndServerErrorContainer, ErrorText, PrivacyStatements, LeadGenFormContainer, LeadGenFormDiv, H4Text, Desc, ButtonsDiv, SpinnerContainerDiv, SpinnerDiv } from './LeadGenForm.styled'
import PrimaryButton from '../../../Buttons/PrimaryButton'
import { Form as FinalForm, Field } from 'react-final-form'
import { useSelector, useDispatch } from 'react-redux'
import userActions from '@takedapdt/biolife-core/src/Stores/Users/Actions'
import importer from '@takedapdt/biolife-core/src/importer'
import chatbotActions from '@takedapdt/biolife-core/src/Stores/Chatbot/Actions'
import validate from './validate'
import getTranslation from '../../utils/getTranslation'
import ButtonCloseIcon from '../../../../../assets/media/icons/button-close-large-light-gray.svg'
  // import {saveSignUp} from '@takedapdt/biolife-core/src/Stores/Users/Actions';
const InputField = importer('Components/Forms/FormFields/InputField')
function LeadGenPopup({data, handlePopupState, CrossCloseCTACompPopup, changeChatbotData}) {
  const {selectedLanguage, ...restProps} = data;
  const [loadingstate, setLoadingState] = useState(false)
  const chatbotResponseSuccess = useSelector((state) => state.chatbot.getChatbotResponseSuccess)
  const dispatch = useDispatch();
  const scrollToShowServerError = useRef();
  const saveSignUp = (user) => dispatch(userActions.saveSignUp(user))
  const [serverErrorMessages, setServerErrorMessages] = useState([])

  const onSubmit = (values) => {
    const { isEmailOptIn = true } = values
    const donor = {
      donorDetails: {
        firstName: values['First Name'],
        lastName: values['Last Name'],
        email: values['Email Address'].toLowerCase(),
        zipCode: values['Zip Code'],
        isEmailOptIn,
        gclickId: getGclickId()
      }
    }
    changeChatbotData((prev)=>{
      return {
        ...prev,
        isLeadGenSubmitted: true
      }
    })
    setLoadingState(true)
    dispatch(chatbotActions.getChatbotResponse({...restProps, ...donor, isLeadGenSubmitted: true}));
  }

  const getGclickId = () => {
    var b = document.cookie.match('(^|;)\\s*' + '_gcl_aw' + '\\s*=\\s*([^;]+)')
    return b ? b.pop().split('.')[2] : null
  }
  
  useEffect(()=>{
    dispatch(chatbotActions.setChatbotResponseSuccess())
    setServerErrorMessages([])
  },[])

  useEffect(()=>{
    // if API is lead gen only then enter
    if (!chatbotResponseSuccess) return;

    const { statusCode = null, headers = null, body } = chatbotResponseSuccess;
    const { api } = headers || {};
    if(body && Object.keys(body).length){
      const dataForSignUp = {
        firstName: body.firstName,
        lastName: body.lastName,
        email: body.email,
        zipCode: body.zipCode,
        isEmailOptIn: true,
        gclickId: getGclickId()
      }
      saveSignUp(dataForSignUp)
    }
    
    if(api === "register"){
      if((statusCode && statusCode===200 || statusCode===201 || statusCode===202)){
        TagManager.dataLayer({
          dataLayer: {
            event: 'profileRegistration',
            profileRegistrationStage: 'profile lead generated',
            donorZip: body.zipCode,
            donorId: body.id,
            bdpDonorId: body.bdpDonorId || null,
            originFrom: 'chatbot'
          }
        })
        CrossCloseCTACompPopup({operation: "automatic", component: "register"})
        handlePopupState((prev)=>{
          return {
            ...prev,
            leadGenSuccessPopup: true
          }
        })
      }else{
        const {message=null} = body || {};
        if (isArray(message)) {
          setServerErrorMessages(message)
        } else {
          setServerErrorMessages([message])
        }
      }
    }
    setLoadingState(false)
    dispatch(chatbotActions.setChatbotResponseSuccess())
    
  },[chatbotResponseSuccess])

  useEffect(()=>{
    if(serverErrorMessages && serverErrorMessages.length){
      scrollToShowServerError.current.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'})
    }
  },[serverErrorMessages])

  return (
    <LeadGenFormContainer>
      <LeadGenCrossContainer >
        <StyledImage src={ButtonCloseIcon} onClick={()=>{
          CrossCloseCTACompPopup({
          operation: "manual",
          component: "register"
          })
        }}/>
      </LeadGenCrossContainer>
      <LeadGenFormDiv ref={scrollToShowServerError}>
        <H4Text>{getTranslation(selectedLanguage, "leadGenFormHeader")}</H4Text>
      </LeadGenFormDiv>
      <FormFieldsDiv>
      <FinalForm
          onSubmit={onSubmit}
          validate={(props)=>{
            return validate(props, selectedLanguage)
          }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FieldAndServerErrorContainer>
                {serverErrorMessages && serverErrorMessages.length ?
                  (<ErrorContainer $serverErrorMessages={serverErrorMessages}>
                    {
                        serverErrorMessages && serverErrorMessages.length && serverErrorMessages.map((error)=>{
                          return <ErrorText>{error}</ErrorText>
                        }) || <></>
                    }
                </ErrorContainer>) : <></>}
                <FieldContainer>
                  <Field name={"First Name"}>
                    {({ input, meta }) => (
                      <InputField
                        meta={meta}
                        {...input}
                        required={true}
                        fieldLabel={getTranslation(selectedLanguage, "leadGenFirstNameFieldName")}
                        id={"First Name"}
                      />
                    )}
                  </Field>
                </FieldContainer>
                <FieldContainer>
                  <Field name={"Last Name"}>
                    {({ input, meta }) => (
                      <InputField
                        meta={meta}
                        {...input}
                        required={true}
                        fieldLabel={getTranslation(selectedLanguage, "leadGenLastNameFieldName")}
                        id={"Last Name"}
                      />
                    )}
                  </Field>
                </FieldContainer>
                <FieldContainer>
                  <Field name={"Email Address"}>
                    {({ input, meta }) => (
                      <InputField
                        meta={meta}
                        {...input}
                        required={true}
                        fieldLabel={getTranslation(selectedLanguage, "leadGenFieldName")}
                        id={"Email Address"}
                      />
                    )}
                  </Field>
                </FieldContainer>
                <FieldContainer>
                  <Field name={"Zip Code"}>
                    {({ input, meta }) => (
                      <InputField
                        meta={meta}
                        {...input}
                        required={true}
                        fieldLabel={getTranslation(selectedLanguage, "leadGenZipCodeFieldName")}
                        id={"Zip Code"}
                      />
                    )}
                  </Field>
                </FieldContainer>
              </FieldAndServerErrorContainer>
              <PrivacyStatements>
                <Privacy1stdiv dangerouslySetInnerHTML={{ __html: getTranslation(selectedLanguage, "leadGenPrivacyStatement") }}/>
                <Privacy2nddiv dangerouslySetInnerHTML={{ __html: getTranslation(selectedLanguage, "leadGenPrivacy2ndStatement") }}/>
              </PrivacyStatements>
              {
                loadingstate ? (
                  <SpinnerContainerDiv>
                    <SpinnerDiv/>
                  </SpinnerContainerDiv>
                ) : (
                <ButtonsDiv>
                  <PrimaryButton 
                    type="submit" 
                    text={getTranslation(selectedLanguage, "leadGenSubmit")} 
                    fluid 
                  />
                  <PrimaryButton
                    type="button"
                    variant='blue_underline'
                    text={getTranslation(selectedLanguage, "leadGenReturn")}
                    fluid
                    onClick={()=>{
                      CrossCloseCTACompPopup({
                      operation: "manual",
                      component: "register"
                      })
                    }}
                  />
                </ButtonsDiv>
                )
              }
            </form>
          )}
        />
      </FormFieldsDiv>
    </LeadGenFormContainer>
  )
}

export default LeadGenPopup
